<script lang="ts">
  import DefaultPopup from './DefaultPopup.svelte';
  import AutomationBlock from './../blocks/AutomationBlock.svelte';
  import { logout } from '../../store/auth.store';
    import ImageUploader from '../../ImageUploader.svelte';
    import SendTo from '../../SendTo.svelte';
    import {
    readAsArrayBuffer,
    readAsImage,
    readAsPDF,
    readAsDataURL,
  } from "../../utils/asyncReader.js";

  import { onMount, onDestroy, createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  
  import { ggID, timeout } from "../../utils/helper.js";
  import prepareAssets, { fetchFont } from "../../utils/prepareAssets.js";
  import { timeAgo } from "../../store/timeAgo.js";
  import CopyClipBoard from "../../CopyClipBoard.svelte";
  import { subscribeIsMobile } from "../../views/sign/utils/media.js";
  import {
    groupSignsByDay,
    formatSentDate,
  } from "../../views/sign/utils/dateGroups.js";

  import { save, getData, getPdfPageData } from "../../utils/PDF.js";
  import { buildSignUrl, QIX_ORIGIN } from "../../utils/signPublicUrl.js";

    import Template from '../../Template.svelte';
    import CheckMark from '../../CheckMark.svelte';
  export let user;
  export let isOpen = true;
  export let emailSubject;
  export let emailCC;
  enum Tab {
    Pending = 'messaging',
    Completed = 'completed',
    Templates = 'auto',
    Integration = 'integration',
    Team = 'team'
  }
  let logo = "/img/default_image.svg";
  let blog = { siteurl: QIX_ORIGIN };
  let isMobile = false;
  let userDetailsOpen = false;
  let chromeCollapsed = false;
  /** When true (e.g. Templates share Email/SMS), ignore scroll-to-collapse chrome */
  let chromeScrollLocked = false;
  /** Ignore scroll-driven chrome updates (date chips / layout reflow after toggle) */
  let chromeIgnoreUntil = 0;
  let chromeScrollAccum = 0;
  let pendingDateFilter = '';
  let pendingListEl;
  let menuInnerEl;
  let sheetDragY = 0;
  let sheetDragging = false;
  let grabStartY = 0;
  const lastListScrollTop = new WeakMap();
  const unsubscribeMobile = subscribeIsMobile((v) => {
    isMobile = v;
  });

  $: companyDisplay = [user?.name, user?.surname]
    .filter(Boolean)
    .join(' ')
    .trim();

  $: displayEmail = String(user?.email || user?.user_email || '').trim();
  $: displayAppId = String(
    user?.appId || user?.id || user?.ID || user?.app_id || ''
  ).trim();

  function toggleUserDetails() {
    if (!isMobile) return;
    userDetailsOpen = !userDetailsOpen;
  }

  function closeMenu() {
    sheetDragY = 0;
    sheetDragging = false;
    applySheetDrag(0, false);
    newProfilePanel = false;
  }

  function getSheetEl() {
    return menuInnerEl?.closest?.('.popup__inner.main-menu-popup') || null;
  }

  function applySheetDrag(y, dragging) {
    const el = getSheetEl();
    if (!el) return;
    el.style.setProperty('--sheet-drag-y', `${y}px`);
    el.classList.toggle('main-menu-popup--dragging', dragging);
  }

  function onGrabPointerDown(event) {
    if (!isMobile) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    sheetDragging = true;
    grabStartY = event.clientY;
    sheetDragY = 0;
    applySheetDrag(0, true);
    try {
      event.currentTarget.setPointerCapture?.(event.pointerId);
    } catch (_) {}
    window.addEventListener('pointermove', onGrabPointerMove);
    window.addEventListener('pointerup', onGrabPointerUp);
    window.addEventListener('pointercancel', onGrabPointerUp);
  }

  function onGrabPointerMove(event) {
    if (!sheetDragging) return;
    const delta = event.clientY - grabStartY;
    // Drag up (negative) dismisses; dampen slight downward pull
    sheetDragY = delta < 0 ? delta : delta * 0.15;
    applySheetDrag(sheetDragY, true);
  }

  function onGrabPointerUp() {
    if (!sheetDragging) return;
    window.removeEventListener('pointermove', onGrabPointerMove);
    window.removeEventListener('pointerup', onGrabPointerUp);
    window.removeEventListener('pointercancel', onGrabPointerUp);
    const shouldClose = sheetDragY < -100;
    const dragged = Math.abs(sheetDragY) > 8;
    sheetDragging = false;
    // Re-enable transition for snap-back or close
    applySheetDrag(sheetDragY, false);
    if (shouldClose) {
      // Continue sliding up off-screen, then close
      requestAnimationFrame(() => {
        closeMenu();
      });
    } else {
      // Smooth snap back to rest
      requestAnimationFrame(() => {
        sheetDragY = 0;
        applySheetDrag(0, false);
      });
    }
    if (dragged) {
      const suppress = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.removeEventListener('click', suppress, true);
      };
      window.addEventListener('click', suppress, true);
    }
  }

  function pauseChromeScroll(ms = 500) {
    chromeIgnoreUntil = Date.now() + ms;
    chromeScrollAccum = 0;
  }

  function setChromeCollapsed(next) {
    if (next === chromeCollapsed) return;
    // Ignore list reflow noise while the CSS slide animation runs
    chromeIgnoreUntil = Date.now() + 340;
    chromeScrollAccum = 0;
    chromeCollapsed = next;
    if (next) userDetailsOpen = false;
  }

  function handleMenuListScroll(event) {
    if (!isMobile) return;
    if (chromeScrollLocked) return;

    // Pending / Completed / Templates / Team list views use scroll-to-collapse chrome
    if (
      activeTab !== Tab.Pending &&
      activeTab !== Tab.Completed &&
      activeTab !== Tab.Templates &&
      activeTab !== Tab.Team
    ) {
      return;
    }

    const el = event.target;
    if (!(el instanceof HTMLElement)) return;
    if (el === menuInnerEl) return;

    // Share / contact pickers / modals: never collapse chrome while scrolling them
    if (
      el.closest(
        [
          '[data-no-chrome-scroll]',
          '.select-menu-wrap',
          '.select-menu',
          '.contact-card',
          '.share-flow-panel',
          '.share-flow-menu',
          '.modal-content',
          '.packets-modal',
          '.template-wrapper--sharing',
        ].join(',')
      )
    ) {
      if (chromeCollapsed) setChromeCollapsed(false);
      return;
    }

    // Only designated list scrollers (pending / completed / templates / team)
    if (!el.hasAttribute('data-menu-chrome-scroll')) return;
    if (el.scrollHeight <= el.clientHeight + 2) return;

    const scrollTop = el.scrollTop;
    const prev = lastListScrollTop.has(el) ? lastListScrollTop.get(el) : scrollTop;
    const delta = scrollTop - prev;
    lastListScrollTop.set(el, scrollTop);

    // Date-chip / programmatic jumps / post-toggle reflow — keep chrome stable
    if (Date.now() < chromeIgnoreUntil) {
      chromeScrollAccum = 0;
      return;
    }

    // Ignore sub-pixel / rubber-band jitter (common on real iOS/Android)
    if (Math.abs(delta) < 2) return;

    // Near the top: always show chrome immediately
    if (scrollTop <= 10) {
      chromeScrollAccum = 0;
      if (chromeCollapsed) setChromeCollapsed(false);
      return;
    }

    // Reset accum when direction flips
    if ((delta > 0 && chromeScrollAccum < 0) || (delta < 0 && chromeScrollAccum > 0)) {
      chromeScrollAccum = 0;
    }
    chromeScrollAccum += delta;

    // Immediate toggle (smooth CSS animation) once scroll intent is clear
    if (chromeScrollAccum > 28) {
      setChromeCollapsed(true);
    } else if (chromeScrollAccum < -22) {
      setChromeCollapsed(false);
    }
  }

  function onTemplateChromeLock(event) {
    const lock = !!(event && event.detail && event.detail.lock);
    chromeScrollLocked = lock;
    if (lock) {
      pauseChromeScroll(300);
      chromeCollapsed = false;
      userDetailsOpen = false;
    }
  }

  function bindMenuScrollRoot(node) {
    menuInnerEl = node;
    const onScroll = (event) => handleMenuListScroll(event);
    node.addEventListener('scroll', onScroll, true);
    return {
      destroy() {
        node.removeEventListener('scroll', onScroll, true);
        if (menuInnerEl === node) menuInnerEl = null;
      },
    };
  }

  async function copyAppId() {
    const id = displayAppId;
    if (!id) return;
    try {
      await navigator.clipboard.writeText(String(id));
    } catch (_) {
      /* ignore */
    }
  }

  $: pendingGrouped = groupSignsByDay(
    (pendingSignature || []).filter(
      (sign) =>
        !searchKeyPending ||
        (sign.attachmentName || '')
          .toLowerCase()
          .includes(searchKeyPending.toLowerCase())
    )
  );

  $: pendingVisibleGroups = pendingDateFilter
    ? pendingGrouped.filter((g) => g.key === pendingDateFilter)
    : pendingGrouped;

  function conversationUrl(sign) {
    const chatId =
      sign.chatId ||
      sign.chat_id ||
      sign.conversationId ||
      sign.author_id ||
      '';
    if (!chatId) return 'https://legalpal.app/chat';
    return `https://legalpal.app/chat?chatId=${encodeURIComponent(chatId)}`;
  }

  function scrollToPendingDay(key) {
    // Keep header/tabs/date chips stable — chip taps must not collapse chrome
    pauseChromeScroll(700);
    chromeCollapsed = false;
    pendingDateFilter = pendingDateFilter === key ? '' : key;
    if (pendingListEl) {
      // Jump to top of filtered list; avoid smooth scrollIntoView (fires noisy scroll on phones)
      pendingListEl.scrollTop = 0;
      lastListScrollTop.set(pendingListEl, 0);
    }
  }

  async function get_company_logo() {
    let body = { appId: user.appId, email: user.email };
    const req = await fetch(blog.siteurl + "/ajax/logo.php", {
      method: "POST",
      body: JSON.stringify(body),
    });
    let res = await req.json();
    logo = res.logo.replace("{{api}}", "https://api.qix.cloud/");
  }
  async function handleLogoUpload(img) {
    logo = img.replace(
      "https://drive.google.com/uc?export=view&id=",
      "https://lh3.google.com/u/0/d/"
    );
    let body = { appId: user.appId, email: user.email, logo: logo };
    const req = await fetch(blog.siteurl + "/ajax/logo.php", {
      method: "POST",
      body: JSON.stringify(body),
    });
    await req.json();
  }

  export let activeTab:Tab = Tab.Pending;
  export let newProfilePanel = true; // Initialize searchKeyPending
  export let searchKeyPending; // Initialize searchKeyPending
  export let pendingSignature; // Initialize searchKeyPending
  export let signatureTabLoading; // Initialize searchKeyPending
  export let friends; // Initialize searchKeyPending
  export let showArchive; // Initialize searchKeyPending
  export let completedSignature; // Initialize searchKeyPending
  export let templates; // Initialize searchKeyPending

  export let emailNotifyAvailable;
  export let searchKeyCompleted; // Initialize searchKeyPending
  export let completedArchived; // Initialize searchKeyPending
  let showSettingsPanel = false;
  export let sendToId;
  export let showSignatureTab;
  export let completedPDFUrl;
  export let selectedPageIndex;
  export let pdfName;
  export let loadingTemplate;
  export let chatUsers; // Initialize searchKeyPending
  export let users; // Initialize searchKeyPending
  export let merusToken = ""; // Initialize searchKeyPending
  export let pdfFile; // Initialize searchKeyPending
  export let pages; // Initialize searchKeyPending
  export let allObjects; // Initialize searchKeyPending
  export let pagesScale; // Initialize searchKeyPending
  export let quickSigns; // Initialize searchKeyPending
  export let editTemplatesAvailable;
  export let multiplePdfs; 
  export let processingSaveTemplate;
  export let completedSaveTemplate; 
  export let selectedMerusUserId;
  export let selectedMerusActivityTypeId;
  export let selectedSharepoint;
  export let signColor; // Initialize searchKeyPending
  export let templateId; // Initialize searchKeyPending
  export let pdfBlobFile; // Initialize searchKeyPending
  export let pdfFiles;
  export let tempThumb;
  export let sendPDFType; // Initialize searchKeyPending
  export let layerPos;
  export let addTextMenu;
  export let currentFont;
  export let signatureMenu;
  export let tutorialNumber;
  export let teamViewCompletedDocAvailable;
  export let shareSettingsAvailable;
  export let searchKeyFriend;
  export let inviteFriendPanel = false;
  export let inviteClipboardTxt;
  export let clipboardTxt;
  export let merusCaseEnabled;
  export let fileVineEnabled;
  export let fluentCaseEnabled;
  export let fluentCaseToken;
  export let twilioEnabled;
  export let microsoftSharepointTenantId;

  async function getArchivedSignature() {
    // Keep in-app mock archive rows for mobile UX / smoke tests
    try {
      if (
        typeof window !== 'undefined' &&
        new URLSearchParams(window.location.search).get('mockUser') === '1'
      ) {
        if (!Array.isArray(completedArchived) || completedArchived.length === 0) {
          completedArchived = [
            {
              id: 'a1',
              pdfName:
                'Archived_Settlement_Release_Client_Very_Long_Document_Name_Final.pdf',
              date: '04/12/2026',
              attachmentUrl: 'https://qix.cloud/mock/archived1.pdf',
            },
            {
              id: 'a2',
              pdfName: 'Old Engagement Letter.pdf',
              date: '03/01/2026',
              attachmentUrl: 'https://qix.cloud/mock/archived2.pdf',
            },
          ];
        }
        signatureTabLoading = false;
        return;
      }
    } catch (_) {
      /* ignore */
    }
    signatureTabLoading = true;
    let body = {
      auth: "google",
      user_id: user.id,
      email: user.email,
      team: friends,
    };
    const req = await fetch(
      blog.siteurl + "/wp-admin/admin-ajax.php?action=getArchivedSignature",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    completedArchived = await req.json();
    signatureTabLoading = false;
  }


  const copyInviteUrl = () => {
    clipboardTxt = inviteClipboardTxt;
    const app = new CopyClipBoard({
      target: document.getElementById("inviteclipboard"),
      props: { clipboardTxt },
    });

    app.$destroy();
    //clipboardTxt = "";
    //usersPanel = false;
    alert("Copied.");
  };


  async function getTeamViewCompletedDocAvailable(status = "") {
    let body = { user_id: user.appId };
    if (status != "") {
      body = { user_id: user.appId, available: status };
    }
    const req = await fetch(
      blog.siteurl + "/ajax/view_completed_documents_available.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    teamViewCompletedDocAvailable = res.available == "disable" ? false : true;
  }

  async function getShareSettingsAvailable(status = "") {
    let body = { user_id: user.id };
    if (status != "") {
      body = { user_id: user.id, available: status };
    }
    const req = await fetch(
      blog.siteurl + "/ajax/share_settings_available.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    shareSettingsAvailable = res.available == "disable" ? false : true;
  }

  async function editTemplatesAvailableFunc(status = "") {
    let body = { user_id: user.appId };
    if (status != "") {
      body = { user_id: user.appId, available: status };
    }
    const req = await fetch(
      blog.siteurl + "/ajax/edit_template_available.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    editTemplatesAvailable = res.available == "disable" ? false : true;
  }
  async function getPageDimension() {
    const pageData = await getPdfPageData(pdfFile);

    for (const [file] of pdfFiles) {
      const data = await getPdfPageData(file);
      pageData.push(...data);
    }

    return pageData;
  }
  async function getSignatureOptions(contact_id = 0) {
    const prePdfData = await getData(pdfFile, allObjects, pdfName, pagesScale);
    //let pdfData = "data:application/pdf;base64,"  +  prePdfData[0];
    let pdfData = prePdfData[0];
    pdfBlobFile = pdfData;
    let optionData = prePdfData[1];
    if (pdfFiles.length > 0) {
      let tempSignatures = [];
      const pageData = await getPageDimension();
      for (let pageIndex = 0; pageIndex < allObjects.length; pageIndex++) {
        const objects = allObjects[pageIndex];
        const pageWidth = pageData[pageIndex].width;
        const pageHeight = pageData[pageIndex].height;
        for (let i = 0; i < objects.length; i++) {
          const object = objects[i];
          if (object.type === "Signature") {
            let { file, x, y, width, height } = object;
            let tmp = {
              type: object.type,
              url: file,
              x,
              y,
              width,
              height,
              pageIndex,
              pageWidth,
              pageHeight,
            };
            tempSignatures.push(tmp);
          } else if (object.type === "quickSign") {
            let { file, x, y, width, height } = object;
            let tmp = {
              type: object.type,
              url: file,
              x,
              y,
              width,
              height,
              pageIndex,
              pageWidth,
              pageHeight,
            };
            tempSignatures.push(tmp);
          } else if (object.type === "text") {
            let { text, x, y, width,size } = object;
            let tmp = {
              type: object.type,
              text: text,
              x,
              y,
              width,
              pageIndex,
              pageWidth,
              pageHeight,
              size
            };
            tempSignatures.push(tmp);
          }
        }
      }
      optionData = tempSignatures;
    }
    let sign1 = "";
    let sign2 = "";
    let sign3 = "";
    let sign4 = "";
    let sign5 = "";
    let sign6 = "";
    for (let i = 0; i < optionData.length; i++) {
      const pageNum = optionData[i].pageIndex + 1;
      let pageWidth = optionData[i].pageWidth;
      let pageHeight = optionData[i].pageHeight;
      let size = optionData[i].size;
      if (pageWidth == 792 && pageHeight == 612) {
        if (optionData[0].pageWidth == 612 && optionData[0].pageHeight == 792) {
          pageWidth = 612;
          pageHeight = 792;
        }
      }
      if (optionData[i].type == "text") {
        //console.log(optionData[i].pageWidth, optionData[i].pageHeight);
        let posX = optionData[i].x / pageWidth;
        let posY = (optionData[i].y + 15) / pageHeight;
        if (optionData[i].text == "Initial") {
          if (sign2 == "") {
            sign2 += pageNum + ":" + posX + ":" + posY + ":" + size;
          } else {
            sign2 += "," + pageNum + ":" + posX + ":" + posY + ":" + size;
          }
        } else if (optionData[i].text == "Date") {
          if (sign3 == "") {
            sign3 += pageNum + ":" + posX + ":" + posY + ":" + size;
          } else {
            sign3 += "," + pageNum + ":" + posX + ":" + posY + ":" + size;
          }
        } else if (optionData[i].text == "Name") {
          if (sign4 == "") {
            sign4 += pageNum + ":" + posX + ":" + posY + ":" + size;
          } else {
            sign4 += "," + pageNum + ":" + posX + ":" + posY + ":" + size;
          }
        } else {
          //console.log("optionData", i, optionData);
          if (sign5 == "") {
            sign5 +=
              pageNum + ":" + posX + ":" + posY + ":" + optionData[i].text.replace(/,/g, "-*-").replace(/:/g, "_*_") + ":" + size;
          } else {
            sign5 +=
              "," +
              pageNum +
              ":" +
              posX +
              ":" +
              posY +
              ":" +
              optionData[i].text.replace(/,/g, "-*-").replace(/:/g, "_*_") + ":" + size;
          }
        }
      } else {
        let posX = optionData[i].x / pageWidth;
        let posY = optionData[i].y / (pageHeight - 23);
        if (optionData[i].type == "quickSign") {
          let path = optionData[i].url.replace(blog.siteurl, "");
          if (sign6 == "") {
            sign6 += pageNum + ":" + posX + ":" + posY + ":" + path;
          } else {
            sign6 += "," + pageNum + ":" + posX + ":" + posY + ":" + path;
          }
        }
        if (optionData[i].type == "Signature") {
          if (sign1 == "") {
            sign1 += pageNum + ":" + posX + ":" + posY;
          } else {
            sign1 += "," + pageNum + ":" + posX + ":" + posY;
          }
        }
      }
    }
    let timestamp = 0;
    let option1 = sign1 + "--*--" + sign3;
    let option2 =
      sign2 +
      "--*--" +
      sign4 +
      "--*--" +
      sign5 +
      "--*--letter--*--" +
      timestamp +
      "--*--" +
      sign6;
    let display_name = "google_" + user.name;
    let body = {
      author_id: user.id,
      author: display_name,
      contact_id: contact_id,
      pdfData: pdfData,
      pdfName: pdfName && !pdfName.toLowerCase().endsWith('.pdf') ? pdfName + '.pdf' : pdfName,
      option1: option1,
      option2: option2,
      sendPDFType: sendPDFType,
      allObjects: allObjects,
    };
    return body;
  }
  async function saveTemplate() {
    processingSaveTemplate = true;
    completedSaveTemplate = false;
    let body = await getSignatureOptions();
    body.templateId = templateId;
    body.thumbnail = tempThumb;
    body.auth = "google";
    //console.log("body", body);
    const res = await fetch(
      blog.siteurl +
        "/wp-admin/admin-ajax.php?action=saveTemplateFromCloudFlare",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let data = await res.json();
    templateId = data;
    
    if (user.id != "") {
      let body = {
        auth: "google",
        user_id: user.id,
        app_id: user.appId,
        email: user.email,
        team: friends,
      };
      const req = await fetch(
        "https://qix.cloud" +
        "/wp-admin/admin-ajax.php?action=getSignatureListForCloudflare",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      pendingSignature = data.pending;
      showArchive = false;
      completedSignature = data.completed;
      templates = data.templates;
    }
    processingSaveTemplate = false;
    completedSaveTemplate = true;
    setTimeout(() => {
      completedSaveTemplate = false;
    }, 1500);
    showSignatureTab = false;
  }
  async function handleLoadTemplate(event) {
    newProfilePanel = false;
    console.log("loadTemplate in mainMenu", event);
    let template = event.detail.template;
    dispatch("select", { template });
    // loadTemplate(event.detail.template);
  }
  async function loadTemplate(template) {
    selectedPageIndex = -1;
    loadingTemplate = true;
    selectedMerusUserId = template.merusUserId;
    selectedMerusActivityTypeId = template.activity_type_id;
    selectedSharepoint = template.sharepoint;
    showSignatureTab = false;
    let body = { url: template.pdfUrl, auth: "google" };
    const res = await fetch(
      blog.siteurl + "/wp-admin/admin-ajax.php?action=loadTemplateCloudFlare",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let pdfBlob = await res.blob();
    selectedPageIndex = 0;
    await addPDF(pdfBlob);
    pdfName = template.pdfName;
    let Objs = JSON.parse(template.allObjects);
    for (var i = 0; i < Objs.length; i++) {
      for (var j = 0; j < Objs[i].length; j++) {
        let obj = Objs[i][j];
        layerPos = { x: obj.x, y: obj.y };
        selectedPageIndex = i;
        if (obj.type == "Signature") {
          await addSignImage(obj.file, 1);
        }
        if (obj.type == "quickSign") {
          await addQuickSignImage(obj.file, 1);
        }
        if (obj.type == "text") {
          addTextField(obj.text, true);
        }
      }
    }
    //console.log(selectedPageIndex);
    templateId = template.id;
    template.loaded = true;
    templates = templates.map((temp, tIndex) =>
      temp.id == templateId ? template : temp
    );
    setTimeout(function () {
      window.scrollTo({ top: 0, behavior: "auto" });
      loadingTemplate = false;
    }, 1000);
  }
  const genID = ggID();
  function addTextField(text = "New Text Field", pos = false) {
    addTextMenu = false;
    const id = genID();
    fetchFont(currentFont);
    const object = {
      id,
      text,
      type: "text",
      size: 16,
      width: 0, // recalculate after editing
      lineHeight: 1.4,
      fontFamily: currentFont,
      x: 0,
      y: 0,
    };
    if (pos) {
      object.x = layerPos.x;
      object.y = layerPos.y;
    }
    allObjects = allObjects.map((objects, pIndex) =>
      pIndex === selectedPageIndex ? [...objects, object] : objects
    );
  }
  async function addQuickSignImage(url, p) {
    try {
      // get dataURL to prevent canvas from tainted
      const file = url;
      const img = await readAsImage(url);
      const id = genID();
      const { width, height } = img;
      signatureMenu = false;
      const object = {
        id,
        type: "quickSign",
        width,
        height,
        x: layerPos.x,
        y: layerPos.y,
        payload: img,
        file,
      };
      if (p == 0) {
        object.x = 0;
        object.y = 0;
      }
      allObjects = allObjects.map((objects, pIndex) =>
        pIndex === selectedPageIndex ? [...objects, object] : objects
      );
    } catch (e) {
      console.log(`Fail to add image.`, e);
    }
  }

  async function addSignImage(url = "", p) {
    try {
      if (url == "") {
        if (signColor == 0) {
          url = "https://qix.cloud/img/sign_hear.png";
        } else {
          url = "https://qix.cloud/img/sign_hear.png";
        }
      }
      // get dataURL to prevent canvas from tainted
      const file = url;
      const img = await readAsImage(url);
      const id = genID();
      const { width, height } = img;
      console.log(width, height, "width height menu");
      signatureMenu = false;
      const object = {
        id,
        type: "Signature",
        width,
        height,
        x: layerPos.x,
        y: layerPos.y,
        payload: img,
        file,
      };
      if (p == 0) {
        object.x = 0;
        object.y = 0;
      }
      allObjects = allObjects.map((objects, pIndex) =>
        pIndex === selectedPageIndex ? [...objects, object] : objects
      );
    } catch (e) {
      console.log(`Fail to add image.`, e);
    }
  }
  // Initialize searchKeyPending
   // Initialize searchKeyPending
   function isJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
   async function viewCompletedDoc(sign) {
    const pdfs = sign.signedPdf;
    if (isJSON(pdfs)) {
      let pdfData = JSON.parse(pdfs);
      pdfData.forEach((data, index) => {
        setTimeout(() => {
          window.open(blog.siteurl + data.link, "_blank");
        }, index * 500); // 500ms delay between tabs
      });
    } else {
      window.open(blog.siteurl + pdfs, "_blank");
    }
  }
  async function editCompletedDoc(pdfs, name,attachmentUrl) {
    showSignatureTab = false;
    newProfilePanel = false;
    loadingTemplate = true;
    completedPDFUrl = attachmentUrl;
    let pdfUrl = pdfs;
    if (isJSON(pdfs)) {
      let pdfData = JSON.parse(pdfs);
      pdfUrl = blog.siteurl + pdfData[0].link;
      completedPDFUrl = pdfUrl;
    }
    let body = { url: pdfUrl, auth: "google" };
    const res = await fetch(
      blog.siteurl + "/wp-admin/admin-ajax.php?action=loadTemplateCloudFlare",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let pdfBlob = await res.blob();
    selectedPageIndex = 0;
    await addPDF(pdfBlob);
    pdfName = name;
    loadingTemplate = false;
  }

  async function addPDF(file) {
    try {
      getSignatures();
      const pdf = await readAsPDF(file);
      pdfName = file.name;
      pdfFile = file;
      const numPages = pdf.numPages;
      pages = Array(numPages)
        .fill()
        .map((_, i) => pdf.getPage(i + 1));
      allObjects = pages.map(() => []);
      pagesScale = Array(numPages).fill(1);
    } catch (e) {
      console.log("Failed to add pdf.");
      throw e;
    }
  }
  async function getSignatures() {
    if (quickSigns.length < 1) {
      let body = {
        auth: "google",
        user_id: user.id,
        email: user.email,
      };
      const signs_req = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=getSignItQuickSign",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      quickSigns = await signs_req.json();
    }
  }
  
  function updateSendToId(id) {
    sendToId = sendToId == id ? 0 : id;
    // sendToType = "";
    // merusToken = "";
    // caseFileId = "";
    // merusTokenPanel = false;
  }
  async function deleteArchivedSignature(id) {
    if (confirm("Are you sure you want to delete the signature?") == true) {
      signatureTabLoading = true;
      let body = {
        id: id,
        auth: "google",
        user_id: user.id,
        email: user.email,
        team: friends,
      };
      const req = await fetch(
        blog.siteurl +
          "/wp-admin/admin-ajax.php?action=deleteArchivedSignature",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      completedArchived = await req.json();
      signatureTabLoading = false;
    }
  }

  async function getEmailNotifyAvailable(status = "") {
    let body = { user_id: user.appId, available: "" };
    if (status != "") {
      body = { user_id: user.appId, available: status };
    }
    const req = await fetch(
      blog.siteurl + "/ajax/sender_notify_available.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    emailNotifyAvailable = res.available == "disable" ? false : true;
  }
  async function sendToFunc(event) {
    if (event.detail.error == "") {
      updateSendToId(event.detail.signId);
      alert("Sent successfully!");
    } else {
      alert(event.detail.error);
    }
  }
  async function resendSignature(id) {
    if (confirm("Are you sure you want to resend the signature?") == true) {
      signatureTabLoading = true;
      let body = { id: id };
      const req = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=resendSignatureProcess",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      alert("Sent!");
    }
  }
  async function deleteSignature(id) {
    if (confirm("Are you sure you want to delete the signature?") == true) {
      signatureTabLoading = true;
      let body = {
        id: id,
        auth: "google",
        user_id: user.id,
        email: user.email,
        team: friends,  
      };
      const req = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=deleteSignatureProcess",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      pendingSignature = data.pending;
      showArchive = false;
      completedSignature = data.completed;
      templates = data.templates;
      signatureTabLoading = false;
    }
  }

  async function displayArchive() {
    await getArchivedSignature();
    showArchive = true;
    showSettingsPanel = false;
  }

  function toggleSettings() {
    showSettingsPanel = !showSettingsPanel;
    showArchive = false;
  }

  function closeSettings() {
    showSettingsPanel = false;
  }

  function closeArchive() {
    showArchive = false;
  }
  
  async function shareSignature(title, text, url) {
    const shareData = {
      title: title,
      text: text,
      url: url,
    };
    try {
      await navigator.share(shareData);
      //alert('Shared successfully');
    } catch (err) {
      alert(err);
    }
  }
  $: activeTabClass = (tab:Tab):string => {
    return activeTab == tab ? 'main-menu-popup__tab--active' : '';
  };

  $: activeViewPosition = (tab:Tab):string => {
    if (activeTab == Tab.Pending) {
      if (tab == Tab.Pending) {
        return '';
      } else {
        return 'main-menu-popup__view--right';
        
      }
    } else if (activeTab == Tab.Completed) {
      if (tab == Tab.Completed) {
        return '';
      } else if (tab != Tab.Pending) {
        return 'main-menu-popup__view--right';
      } else {
        return 'main-menu-popup__view--left';
      }
    }
    else if (activeTab == Tab.Templates) {
      if (tab == Tab.Templates) {
        return '';
      } else if (tab != Tab.Pending && tab != Tab.Completed) {
        return 'main-menu-popup__view--right';
      } else {
        return 'main-menu-popup__view--left';
      }
    }
    else if (activeTab == Tab.Integration) {
      if (tab == Tab.Integration) {
        return '';
      } else if (tab != Tab.Pending && tab != Tab.Completed && tab != Tab.Templates) {
        return 'main-menu-popup__view--right';
      } else {
        return 'main-menu-popup__view--left';
      }
    } 
    else if (activeTab == Tab.Team) {
      if (tab == Tab.Team) {
        return '';
      } else {
        return 'main-menu-popup__view--left';
      }
    }
  };

  $: indicatorClass = 
    activeTab == Tab.Pending 
      ? 'main-menu-popup__tab-indicator--pending' 
      : activeTab == Tab.Completed 
        ? 'main-menu-popup__tab-indicator--completed' 
        : activeTab == Tab.Templates 
          ? 'main-menu-popup__tab-indicator--templates' 
          : activeTab == Tab.Integration 
            ? 'main-menu-popup__tab-indicator--integration' 
            : activeTab == Tab.Team 
              ? 'main-menu-popup__tab-indicator--team' 
              : '';

  export let tutorialStep:number = 0;

  // $: {
  //   if (tutorialStep === 101) {
  //     activeTab = Tab.Messaging
  //   }

  //   if (tutorialStep === 201) {
  //     activeTab = Tab.Automation
  //   }

  //   if (tutorialStep === 301) {
  //     activeTab = Tab.Automation
  //   }

  //   if (tutorialStep === 401) {
  //     activeTab = Tab.Team
  //   }
  // }
  get_company_logo();
  $: console.log('isOpen changed:', isOpen);
  $: console.log('signatureTabLoading changed:', signatureTabLoading);
  $: console.log('newProfilePanel changed:', newProfilePanel);

  onDestroy(() => {
    if (unsubscribeMobile) unsubscribeMobile();
    window.removeEventListener('pointermove', onGrabPointerMove);
    window.removeEventListener('pointerup', onGrabPointerUp);
    window.removeEventListener('pointercancel', onGrabPointerUp);
  });

  $: if (!newProfilePanel) {
    userDetailsOpen = false;
    chromeCollapsed = false;
    chromeScrollLocked = false;
    pauseChromeScroll(0);
  }

  let lastActiveTab = activeTab;
  $: if (activeTab !== lastActiveTab) {
    lastActiveTab = activeTab;
    chromeCollapsed = false;
    chromeScrollLocked = false;
    pauseChromeScroll(300);
  }

</script>
<div>
  {#if true}
    <DefaultPopup
      class="main-menu-popup"
      bind:active={newProfilePanel}
      zIndex="{700}"
      closable={!isMobile}
    >
      <div
        class="main-menu-popup__inner theme-light"
        class:main-menu-popup__inner--chrome-collapsed={isMobile && chromeCollapsed}
        data-testid="main-menu-chrome-root"
        use:bindMenuScrollRoot
      >
        {#if isMobile}
        <div
          class="main-menu-popup__account"
          class:main-menu-popup__account--open={userDetailsOpen}
          data-testid="main-menu-account"
        >
          <div class="main-menu-popup__user">
            <button
              type="button"
              class="main-menu-popup__user-toggle"
              data-testid="main-menu-user-toggle"
              aria-expanded={userDetailsOpen}
              aria-controls="main-menu-account-extra"
              on:click={toggleUserDetails}
            >
              {#if user.google }
                <img class="main-menu-popup__user-type" src="/Google__G__Logo.svg.png" alt="">
              {:else if user.microsoft }
                <img class="main-menu-popup__user-type" src="/microsoft_logo.png" alt="">
              {/if}
              <span class="main-menu-popup__user-email" data-testid="main-menu-user-email">
                {displayEmail || 'Account'}
              </span>
            </button>
            <button
              type="button"
              class="main-menu-popup__logout theme-light"
              on:click={logout}
            >Log Out</button>
          </div>

          <div
            id="main-menu-account-extra"
            class="main-menu-popup__account-extra"
            aria-hidden={!userDetailsOpen}
          >
            <div class="main-menu-popup__account-extra-inner">
              <div class="main-menu-popup__logo-row">
                <ImageUploader
                  src={logo}
                  {user}
                  on:upload={(e) => handleLogoUpload(e.detail.image)}
                />
                <div class="main-menu-popup__logo-meta">
                  <div class="main-menu-popup__logo-label" data-testid="main-menu-company-name">
                    {companyDisplay || 'Company Logo'}
                  </div>
                  <button
                    type="button"
                    class="main-menu-popup__appid main-menu-popup__appid--pill"
                    title={displayAppId ? `Copy AppID ${displayAppId}` : 'AppID unavailable'}
                    data-testid="main-menu-appid"
                    on:click|stopPropagation={copyAppId}
                  >
                    AppID: {displayAppId || '—'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {:else}
        <div class="main-menu-popup__user">
          {#if user.google }
            <img class="main-menu-popup__user-type" src="/Google__G__Logo.svg.png" alt="">
          {:else if user.microsoft }
            <img class="main-menu-popup__user-type" src="/microsoft_logo.png" alt="">
          {/if}
          <span class="main-menu-popup__user-email transition-color">
            { displayEmail }
          </span>
          <button class="main-menu-popup__logout theme-light" on:click={logout}>Log Out</button>
        </div>

        <div
          class="main-menu-popup__appid w-full flex items-center"
          style="padding-left: 10px;font-size: .8em"
        >
          AppID: {displayAppId}
        </div>
        <div
          class="main-menu-popup__logo-row w-full flex items-center"
          style="padding: 15px 0 15px 10px;"
        >
          <ImageUploader
            src={logo}
            {user}
            on:upload={(e) => handleLogoUpload(e.detail.image)}
          />
          <div class="main-menu-popup__logo-label" style="margin-left: 20px;font-size: 1.3em;">
            Company Logo
          </div>
        </div>
        {/if}
        <div class="main-menu-popup__tabs theme-light">
          <div class="main-menu-popup__tab-indicator theme-light {indicatorClass}">&nbsp;</div>
          <button 
            class="main-menu-popup__tab theme-light {tutorialStep === 401 ? 'highlighted' : ''} {activeTabClass(Tab.Pending)}"
            on:click={() => activeTab = Tab.Pending}
            data-testid="main-menu-tab-pending"
          >
            Pending
          </button>
          <button 
            class="main-menu-popup__tab theme-light {activeTabClass(Tab.Completed)}"
            on:click={() => activeTab = Tab.Completed}
            data-testid="main-menu-tab-completed"
          >
            Completed
          </button>
          <button 
            class="main-menu-popup__tab theme-light {tutorialStep === 201 ? 'highlighted' : ''} {activeTabClass(Tab.Templates)}"
            on:click={() => activeTab = Tab.Templates}
            data-testid="main-menu-tab-templates"
          >
           Templates
          </button>
          <button 
            class="main-menu-popup__tab theme-light {tutorialStep === 201 ? 'highlighted' : ''} {activeTabClass(Tab.Integration)}"
            on:click={() => activeTab = Tab.Integration}
            data-testid="main-menu-tab-integration"
          >
           Integration
          </button>
          <button 
            class="main-menu-popup__tab theme-light {tutorialStep === 201 ? 'highlighted' : ''} {activeTabClass(Tab.Team)}"
            on:click={() => activeTab = Tab.Team}
            data-testid="main-menu-tab-team"
          >
           Team
          </button>
        </div>
        {#if isMobile}
          <button
            type="button"
            class="main-menu-popup__grabber"
            data-testid="main-menu-grabber"
            aria-label="Close menu"
            on:click={closeMenu}
            on:pointerdown={onGrabPointerDown}
          >
            <span class="main-menu-popup__grabber-bar" aria-hidden="true"></span>
          </button>
        {/if}
        <div class="main-menu-popup__body">
          <div class="main-menu-popup__view {activeViewPosition(Tab.Pending)}" data-testid="main-menu-pending-view">
            <div class="main-menu-popup__automation main-menu-popup__pending" style="display: flex; flex-direction: column; height: 100%;">
              {#if signatureTabLoading}
                <div class="main-menu-popup__tab-loading" data-testid="main-menu-tab-loading">
                  <img alt="" src="/EmoteHi.gif" style="max-width: 100px;" />
                </div>
              {:else if isMobile}
                <!-- Mobile: date chips + grouped cards + bottom search; upload via FAB -->
                {#if pendingGrouped.length > 0}
                  <div class="main-menu-popup__date-chips" data-testid="pending-date-chips">
                    {#each pendingGrouped as group}
                      <button
                        type="button"
                        class="main-menu-popup__date-chip"
                        class:main-menu-popup__date-chip--active={pendingDateFilter === group.key}
                        data-testid="pending-date-chip"
                        on:click={(e) => {
                          scrollToPendingDay(group.key);
                          e.currentTarget.blur();
                        }}
                      >
                        {group.label}
                      </button>
                    {/each}
                  </div>
                {/if}
                <div
                  class="main-menu-popup__pending-list"
                  bind:this={pendingListEl}
                  data-testid="pending-list-mobile"
                  data-menu-chrome-scroll
                  on:scroll={handleMenuListScroll}
                >
                  {#if pendingVisibleGroups.length > 0}
                    {#each pendingVisibleGroups as group}
                      <div class="main-menu-popup__day-block" data-day-key={group.key}>
                        <div class="main-menu-popup__day-label">{group.label}</div>
                        {#each group.items as sign}
                          <div class="signItem main-menu-popup__doc-card" data-testid="pending-doc-card">
                            <button
                              type="button"
                              class="main-menu-popup__doc-delete"
                              title="Delete"
                              aria-label="Delete"
                              on:click={() => deleteSignature(sign.id)}
                            >
                              <svg class="main-menu-popup__doc-delete-icon" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                  fill="currentColor"
                                  d="M9 3a1 1 0 0 0-1 1v1H5.5a1 1 0 1 0 0 2H6v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7h.5a1 1 0 1 0 0-2H16V4a1 1 0 0 0-1-1H9zm2 2h2v1h-2V5zm-3 4a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1z"
                                />
                              </svg>
                            </button>
                            <div
                              class="main-menu-popup__doc-title"
                              style="display:block;line-height:1.4;margin:0 0 6px;height:auto;white-space:normal;word-break:break-word;overflow-wrap:anywhere;padding-right:32px;"
                            >{sign.attachmentName}</div>
                            <div class="main-menu-popup__doc-meta" style="display:block;line-height:1.4;margin:0 0 4px;height:auto;">{sign.author_email}</div>
                            <div class="main-menu-popup__doc-meta" style="display:block;line-height:1.4;margin:0 0 4px;height:auto;">To: {sign.user_name_pending}</div>
                            <div class="main-menu-popup__doc-meta" style="display:block;line-height:1.4;margin:0 0 4px;height:auto;">Sent: {formatSentDate(sign)}</div>
                            <div class="main-menu-popup__doc-actions">
                              <button type="button" class="main-menu-popup__doc-link" on:click={() => resendSignature(sign.id)}>Resend</button>
                              <button type="button" class="main-menu-popup__doc-link" on:click={() => shareSignature(sign.attachmentName, "", buildSignUrl(sign.id))}>Share</button>
                              <a
                                class="main-menu-popup__jump-btn"
                                href={conversationUrl(sign)}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="jump-to-conversation"
                              >
                                <img alt="" src="/img/chatAsset.svg" />
                                <span>Jump to Conversation</span>
                              </a>
                            </div>
                          </div>
                        {/each}
                      </div>
                    {/each}
                  {:else}
                    <div class="text-center" style="padding: 20px;">There is no data.</div>
                  {/if}
                </div>
                <div class="main-menu-popup__pending-footer">
                  <input
                    placeholder="Search Pending"
                    type="text"
                    class="main-menu-popup__pending-search"
                    bind:value={searchKeyPending}
                    data-testid="pending-search-input"
                  />
                </div>
              {:else}
                <div style="position: sticky; top: 0; background: white; z-index: 10; flex-shrink: 0;">
                  <div style="margin: 10px">
                    <label
                      class="whitespace-no-wrap bg-blue-500 hover:bg-blue-700 text-white
                      font-bold py-1 px-3 md:px-4 rounded mr-3 cursor-pointer md:mr-4"
                      for="pdf"
                    >
                      Choose New PDF
                    </label>
                    <input
                      placeholder="Search Pending"
                      type="text"
                      class="flex-grow bg-transparent py-1 px-2 w-full"
                      style="border: 1px solid;border-radius: 5px;margin-top: 1em;"
                      bind:value={searchKeyPending}
                    />
                  </div>
                </div>
                <div style="flex: 1; overflow-y: auto; min-height: 0; padding: 10px;">
                  {#if pendingSignature && pendingSignature.length > 0}
                    {#each pendingSignature as sign}
                      {#if searchKeyPending == "" || sign.attachmentName
                          .toLowerCase()
                          .includes(searchKeyPending.toLowerCase())}
                        <div class="signItem">
                          <div>
                            <div>{sign.attachmentName}</div>
                          </div>
                          <div>
                            <div>{sign.author_email}</div>
                          </div>
                          <div>
                            <div>To: {sign.user_name_pending}</div>
                          </div>
                          <div class="action w-full flex items-center">
                            <span class="signed">Sent: {sign.date}</span>
                            <div class="flex items-center">
                              <span on:click={() => resendSignature(sign.id)}>Resend</span>
                              <span on:click={() => shareSignature(sign.attachmentName, "", buildSignUrl(sign.id))}>Share</span>
                              <span class="delete" on:click={() => deleteSignature(sign.id)}>Delete</span>
                            </div>
                          </div>
                        </div>
                      {/if}
                    {/each}
                  {:else}
                    <div class="text-center" style="padding: 20px;">There is no data.</div>
                  {/if}
                </div>
              {/if}
            </div>          
          </div>
          <div class="main-menu-popup__view {activeViewPosition(Tab.Completed)}" data-testid="main-menu-completed-view">
            <div class="main-menu-popup__automation" style="display: flex; flex-direction: column; height: 100%;">
              {#if signatureTabLoading}
                <div class="main-menu-popup__tab-loading" data-testid="main-menu-tab-loading">
                  <img alt="" src="/EmoteHi.gif" style="max-width: 100px;" />
                </div>
              {:else}
                <div style="position: sticky; top: 0; background: white; z-index: 10; flex-shrink: 0;">
                  <!-- Search and Action Buttons Row -->
                  <div class="main-menu-popup__toolbar" data-testid="completed-toolbar" style="margin: 10px; display: flex; align-items: center; gap: 10px;">
                    <input
                      placeholder="Search Completed"
                      type="text"
                      class="main-menu-popup__toolbar-search flex-grow bg-transparent py-1 px-2 w-full"
                      style="border: 1px solid;border-radius: 5px;"
                      bind:value={searchKeyCompleted}
                      data-testid="completed-search-input"
                    />
                    <button 
                      class="main-menu-popup__toolbar-btn flex items-center justify-center gap-2 px-4 py-2 border border-gray-300 rounded text-sm hover:bg-gray-50"
                      class:bg-blue-50={showArchive}
                      on:click={displayArchive}
                      style="background: #f8f9fa; color: #374151; border: 1px solid #d1d5db; border-radius: 6px; font-weight: 500;"
                      data-testid="completed-archive-button"
                    >
                      <img
                        alt="Archive"
                        src="/archive_24dp.svg"
                        style="width: 16px; height: 16px;"
                      />
                      <span>Archive</span>
                    </button>
                    <button 
                      class="main-menu-popup__toolbar-btn flex items-center justify-center gap-2 px-4 py-2 border border-gray-300 rounded text-sm hover:bg-gray-50"
                      class:bg-blue-50={showSettingsPanel}
                      on:click={toggleSettings}
                      style="background: #f8f9fa; color: #374151; border: 1px solid #d1d5db; border-radius: 6px; font-weight: 500;"
                      data-testid="completed-settings-button"
                    >
                      <img
                        alt="Settings"
                        src="/settings.png"
                        style="width: 16px; height: 16px;"
                      />
                      <span>Settings</span>
                    </button>
                  </div>
                  
                  <!-- Settings Panel -->
                  {#if showSettingsPanel}
                    <div style="margin: 10px; padding: 15px; border: 1px solid #e5e7eb; border-radius: 8px; background: #f8f9fa;">
                      <div class="flex items-center justify-between mb-3">
                        <h3 style="font-weight: 600; margin: 0;">Settings</h3>
                        <button 
                          on:click={closeSettings}
                          style="background: none; border: none; font-size: 18px; cursor: pointer; color: #6b7280;"
                        >
                          ×
                        </button>
                      </div>
                      <div class="flex items-center gap-4">
                        <b>Notify (email)</b>
                        <div>
                          <input type="radio" id="settings-available-1" name="settings_email_available" checked={emailNotifyAvailable} />
                          <label on:click={() => getEmailNotifyAvailable("enable")} class="tab" for="settings-available-1">Enable</label>
                        </div>
                        <div>
                          <input type="radio" id="settings-available-2" name="settings_email_available" checked={!emailNotifyAvailable} />
                          <label on:click={() => getEmailNotifyAvailable("disable")} class="tab" for="settings-available-2">Disable</label>
                        </div>
                      </div>
                    </div>
                  {/if}
                </div>
                <div
                  class="main-menu-popup__docs-scroll"
                  style="flex: 1; overflow-y: auto; min-height: 0; padding: 10px;"
                  data-testid="completed-list-scroll"
                  data-menu-chrome-scroll
                  on:scroll={handleMenuListScroll}
                >
                  {#if showArchive}
                    <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #e5e7eb;">
                      <div style="font-weight: 600; font-size: 16px;">Archived Documents</div>
                      <button 
                        on:click={closeArchive}
                        style="background: none; border: none; font-size: 18px; cursor: pointer; color: #6b7280; padding: 4px;"
                        title="Close Archive"
                      >
                        ×
                      </button>
                    </div>
                    {#if completedArchived.length > 0}
                      {#each completedArchived as sign}
                        {#if searchKeyCompleted == "" || sign.pdfName.toLowerCase().includes(searchKeyCompleted.toLowerCase())}
                          {#if isMobile}
                            <div class="signItem main-menu-popup__doc-card" data-testid="archived-doc-card">
                              <button
                                type="button"
                                class="main-menu-popup__doc-delete"
                                title="Delete"
                                aria-label="Delete"
                                on:click={() => deleteArchivedSignature(sign.id)}
                              >
                                <svg class="main-menu-popup__doc-delete-icon" viewBox="0 0 24 24" aria-hidden="true">
                                  <path
                                    fill="currentColor"
                                    d="M9 3a1 1 0 0 0-1 1v1H5.5a1 1 0 1 0 0 2H6v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7h.5a1 1 0 1 0 0-2H16V4a1 1 0 0 0-1-1H9zm2 2h2v1h-2V5zm-3 4a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1z"
                                  />
                                </svg>
                              </button>
                              <div class="main-menu-popup__doc-title">{sign.pdfName}</div>
                              <div class="main-menu-popup__doc-meta">Signed: {sign.date}</div>
                              <div class="main-menu-popup__doc-actions">
                                <button
                                  type="button"
                                  class="main-menu-popup__doc-link"
                                  on:click={() => viewCompletedDoc(sign)}
                                >View</button>
                                <button
                                  type="button"
                                  class="main-menu-popup__doc-link main-menu-popup__doc-link--danger"
                                  on:click={() => deleteArchivedSignature(sign.id)}
                                >Delete</button>
                              </div>
                            </div>
                          {:else}
                            <div class="signItem">
                              <div>
                                <div>{sign.pdfName}</div>
                              </div>
                              <div class="action w-full flex items-center">
                                <span class="signed">Signed: {sign.date}</span>
                                <div class="flex items-center">
                                  <span on:click={() => viewCompletedDoc(sign)}>View</span>
                                  <span class="delete" on:click={() => deleteArchivedSignature(sign.id)}>Delete</span>
                                </div>
                              </div>
                            </div>
                          {/if}
                        {/if}
                      {/each}
                    {:else}
                      <div class="text-center">There is no data.</div>
                    {/if}
                  {:else if completedSignature && completedSignature.length > 0}
                    <div class="main-menu-popup__section-title">Completed Documents</div>
                    {#each completedSignature as sign}
                      {#if searchKeyCompleted == "" || sign.attachmentName.toLowerCase().includes(searchKeyCompleted.toLowerCase())}
                        {#if isMobile}
                          <div class="signItem main-menu-popup__doc-card" data-testid="completed-doc-card">
                            <button
                              type="button"
                              class="main-menu-popup__doc-delete"
                              title="Delete"
                              aria-label="Delete"
                              on:click={() => deleteSignature(sign.id)}
                            >
                              <svg class="main-menu-popup__doc-delete-icon" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                  fill="currentColor"
                                  d="M9 3a1 1 0 0 0-1 1v1H5.5a1 1 0 1 0 0 2H6v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7h.5a1 1 0 1 0 0-2H16V4a1 1 0 0 0-1-1H9zm2 2h2v1h-2V5zm-3 4a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1z"
                                />
                              </svg>
                            </button>
                            <div
                              class="main-menu-popup__doc-title"
                              style="display:block;line-height:1.4;margin:0 0 6px;height:auto;white-space:normal;word-break:break-word;overflow-wrap:anywhere;padding-right:32px;"
                            >{sign.attachmentName}</div>
                            {#if sign.author_email}
                              <div class="main-menu-popup__doc-meta" style="display:block;line-height:1.4;margin:0 0 4px;height:auto;">{sign.author_email}</div>
                            {/if}
                            <div class="main-menu-popup__doc-meta" style="display:block;line-height:1.4;margin:0 0 4px;height:auto;">
                              Signed by: {sign.meta && sign.meta[0] && sign.meta[0].author ? sign.meta[0].author : 'N/A'}
                            </div>
                            <div class="main-menu-popup__doc-meta" style="display:block;line-height:1.4;margin:0 0 4px;height:auto;">Signed: {sign.date}</div>
                            <div class="main-menu-popup__doc-actions">
                              <button
                                type="button"
                                class="main-menu-popup__doc-link"
                                on:click={() => editCompletedDoc(sign.signedPdf, sign.attachmentName, sign.attachmentUrl)}
                              >Edit</button>
                              <button
                                type="button"
                                class="main-menu-popup__doc-link"
                                on:click={() => viewCompletedDoc(sign)}
                              >View</button>
                              <button
                                type="button"
                                class="main-menu-popup__doc-link main-menu-popup__doc-link--danger"
                                on:click={() => deleteSignature(sign.id)}
                              >Delete</button>
                            </div>
                            {#if users.length > 0}
                              <SendTo {chatUsers} {users} {sign} {blog} {user} {sendToId} {merusToken} on:update={sendToFunc} />
                            {/if}
                          </div>
                        {:else}
                          <div class="signItem">
                            <div>
                              <div>{sign.attachmentName}</div>
                            </div>
                            <div>
                              <div>{sign.author_email}</div>
                            </div>
                            <div>
                              <span class="signed">Signed by: {sign.meta && sign.meta[0] && sign.meta[0].author ? sign.meta[0].author : 'N/A'}</span>
                            </div>
                            <div class="action w-full flex items-center">
                              <span class="signed">Signed: {sign.date}</span>
                              <div class="flex items-center">
                                <span on:click={() => editCompletedDoc(sign.signedPdf, sign.attachmentName, sign.attachmentUrl)}>Edit</span>
                                <span on:click={() => viewCompletedDoc(sign)}>View</span>
                                <span class="delete" on:click={() => deleteSignature(sign.id)}>Delete</span>
                              </div>
                            </div>
                            {#if users.length > 0}
                              <SendTo {chatUsers} {users} {sign} {blog} {user} {sendToId} {merusToken} on:update={sendToFunc} />
                            {/if}
                          </div>
                        {/if}
                      {/if}
                    {/each}
                  {:else}
                    <div class="text-center" style="padding: 20px;">There is no data.</div>
                  {/if}
                </div>
              {/if}
            </div>          
          </div>
          <div class="main-menu-popup__view {activeViewPosition(Tab.Templates)}" data-testid="main-menu-templates-view">
            <div class="main-menu-popup__automation" style="display: flex; flex-direction: column; height: 100%;">
              {#if signatureTabLoading}
              <div class="main-menu-popup__tab-loading" data-testid="main-menu-tab-loading">
                <img alt="" src="/EmoteHi.gif" style="max-width: 100px;" />
              </div>
              {:else}
              {#if (user.id == user.appId || editTemplatesAvailable) && multiplePdfs.length == 0}
              <div style="margin: 10px">
                {#if processingSaveTemplate}
                  <button
                    class="whitespace-no-wrap py-1 px-3 md:px-4 rounded mr-3 cursor-pointer md:mr-4"
                    class:hidden={selectedPageIndex < 0}
                    style="border: 1px solid grey;"
                  >
                    <img
                      alt=""
                      src="/loading.gif"
                      style="max-width: 30px;"
                    />
                  </button>
                {:else if completedSaveTemplate}
                  <CheckMark />
                {:else}
                  <button
                    on:click={saveTemplate}
                    class="whitespace-no-wrap bg-blue-500 hover:bg-blue-700 text-white
      font-bold py-1 px-3 md:px-4 rounded mr-3 cursor-pointer md:mr-4"
                    class:border-green={tutorialStep == 6 }
                    class:hidden={selectedPageIndex < 0}
                  >
                    Save as Template
                  </button>
                {/if}
              </div>
            {/if}
            <Template
              {chatUsers}
              {merusToken}
              {templates}
              {blog}
              {user}
              {signColor}
              {editTemplatesAvailable}
              bind:emailSubject={emailSubject}
              bind:emailCC={emailCC}
              bind:friends={friends}
              bind:fluentCaseToken={fluentCaseToken}
              bind:merusCaseEnabled={merusCaseEnabled}
              bind:fluentCaseEnabled={fluentCaseEnabled}
              bind:tutorialStep={tutorialStep}
              bind:tutorialNumber={tutorialNumber}
              bind:twilioEnabled={twilioEnabled}
              on:select={handleLoadTemplate}
              on:chromeLock={onTemplateChromeLock}
            />
              {/if}
            </div>          
          </div>
          <div class="main-menu-popup__view {activeViewPosition(Tab.Integration)}" data-testid="main-menu-integration-view">
            <div class="main-menu-popup__automation" style="display: flex; flex-direction: column; height: 100%;">
              {#if signatureTabLoading}
              <div class="main-menu-popup__tab-loading" data-testid="main-menu-tab-loading">
                <img alt="" src="/EmoteHi.gif" style="max-width: 100px;" />
              </div>
              {:else}
              <AutomationBlock bind:user={user} bind:merusCaseEnabled={merusCaseEnabled} bind:fileVineEnabled={fileVineEnabled} bind:fluentCaseToken={fluentCaseToken}  bind:fluentCaseEnabled={fluentCaseEnabled}  bind:microsoftSharepointTenantId={microsoftSharepointTenantId} tutorialStep={tutorialStep} on:close={() => isOpen = false} />
                <!-- <div style="margin: 10px">
                {#if merusCasesEnabled || fileVineEnabled } 
                  <input
                    placeholder="Enter FluentCase API Token"
                    class="flex-grow bg-transparent py-1 px-2 w-full"
                    style="border: 1px solid;border-radius: 5px;margin-bottom: 15px;"
                    bind:value={fluentCaseToken}
                  />
                  <button on:click={setFluentCaseToken(fluentCaseToken)} class="whitespace-no-wrap bg-blue-500 hover:bg-blue-700 text-white
                  font-bold py-1 px-3 md:px-4 rounded mr-3 cursor-pointer md:mr-4">
                    Save FluentCase Token
                  </button>
                {/if}
              </div> -->
              {/if}
            </div>          
          </div>
          <div class="main-menu-popup__view {activeViewPosition(Tab.Team)}">
            <div class="main-menu-popup__automation" style="display: flex; flex-direction: column; height: 100%;">
              {#if signatureTabLoading}
                <div class="main-menu-popup__tab-loading" data-testid="main-menu-tab-loading">
                  <img alt="" src="/EmoteHi.gif" style="max-width: 100px;" />
                </div>
              {:else}
                <div style="position: sticky; top: 0; background: white; z-index: 10; flex-shrink: 0;" class="main-menu-popup__team-sticky" data-testid="main-menu-team-view">
                  <!-- Search and Action Buttons Row -->
                  <div class="main-menu-popup__toolbar main-menu-popup__team-toolbar" style="margin: 10px; display: flex; align-items: center; gap: 10px;">
                    <input
                      placeholder="Search Team"
                      type="text"
                      class="main-menu-popup__toolbar-search flex-grow bg-transparent py-1 px-2 w-full"
                      style="border: 1px solid;border-radius: 5px;"
                      bind:value={searchKeyFriend}
                      data-testid="team-search-input"
                    />
                    <button 
                      class="main-menu-popup__toolbar-btn main-menu-popup__team-btn flex items-center justify-center gap-2 px-4 py-2 border border-gray-300 rounded text-sm hover:bg-gray-50"
                      class:bg-blue-50={inviteFriendPanel}
                      on:click={() => {
                        inviteFriendPanel = !inviteFriendPanel;
                        if (inviteFriendPanel) {
                          // Generate invitation link
                          inviteClipboardTxt = blog.siteurl + "/invite/" + user.appId;
                        }
                      }}
                      style="background: #f8f9fa; color: #374151; border: 1px solid #d1d5db; border-radius: 6px; font-weight: 500; height: 40px; min-height: 40px; white-space: nowrap;"
                      data-testid="team-invite-button"
                    >
                      <img
                        alt="Invitation Link"
                        src="/invite.png"
                        style="width: 16px; height: 16px;"
                      />
                      <span>Invitation Link</span>
                    </button>
                    <button 
                      class="main-menu-popup__toolbar-btn main-menu-popup__team-btn flex items-center justify-center gap-2 px-4 py-2 border border-gray-300 rounded text-sm hover:bg-gray-50"
                      class:bg-blue-50={showSettingsPanel}
                      on:click={toggleSettings}
                      style="background: #f8f9fa; color: #374151; border: 1px solid #d1d5db; border-radius: 6px; font-weight: 500; height: 40px; min-height: 40px;"
                      data-testid="team-settings-button"
                    >
                      <img
                        alt="Settings"
                        src="/settings.png"
                        style="width: 16px; height: 16px;"
                      />
                      <span>Settings</span>
                    </button>
                  </div>
                  
                  <!-- Settings Panel -->
                  {#if showSettingsPanel}
                    <div style="margin: 10px; padding: 15px; border: 1px solid #e5e7eb; border-radius: 8px; background: #f8f9fa;">
                      <div class="flex items-center justify-between mb-3">
                        <h3 style="font-weight: 600; margin: 0;">Edit Template Settings</h3>
                        <button 
                          on:click={closeSettings}
                          style="background: none; border: none; font-size: 18px; cursor: pointer; color: #6b7280;"
                        >
                          ×
                        </button>
                      </div>
                      
                      {#if user.id == user.appId}
                        <div class="flex items-center gap-4 mb-4">
                          <b>Edit Templates (staff)</b>
                          <div>
                            <input
                              type="radio"
                              id="team-edit-available-1"
                              name="team_edit_available"
                              checked={editTemplatesAvailable}
                              on:click={() => editTemplatesAvailableFunc("enable")}
                            />
                            <label class="tab" for="team-edit-available-1">Enable</label>
                          </div>
                          <div>
                            <input
                              type="radio"
                              id="team-edit-available-2"
                              name="team_edit_available"
                              checked={!editTemplatesAvailable}
                              on:click={() => editTemplatesAvailableFunc("disable")}
                            />
                            <label class="tab" for="team-edit-available-2">Disable</label>
                          </div>
                        </div>
                      {/if}
                      
                      <div class="flex items-center gap-4 mb-4">
                        <b>View Completed Documents</b>
                        <div>
                          <input
                            type="radio"
                            id="team-view-completed-1"
                            name="team_view_completed"
                            checked={teamViewCompletedDocAvailable}
                            on:change={() => getTeamViewCompletedDocAvailable("enable")}
                          />
                          <label class="tab" for="team-view-completed-1">Enable</label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="team-view-completed-2"
                            name="team_view_completed"
                            checked={!teamViewCompletedDocAvailable}
                            on:change={() => getTeamViewCompletedDocAvailable("disable")}
                          />
                          <label class="tab" for="team-view-completed-2">Disable</label>
                        </div>
                      </div>

                      <div class="flex items-center gap-4">
                        <b>Share Settings</b>
                        <div>
                          <input
                            type="radio"
                            id="team-share-1"
                            name="team_share"
                            checked={shareSettingsAvailable}
                            on:change={() => getShareSettingsAvailable("enable")}
                          />
                          <label class="tab" for="team-share-1">Enable</label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="team-share-2"
                            name="team_share"
                            checked={!shareSettingsAvailable}
                            on:change={() => getShareSettingsAvailable("disable")}
                          />
                          <label class="tab" for="team-share-2">Disable</label>
                        </div>
                      </div>
                    </div>
                  {/if}
                </div>
                
                <div
                  class="main-menu-popup__docs-scroll"
                  style="flex: 1; overflow-y: auto; min-height: 0; padding: 10px;"
                  data-testid="team-list-scroll"
                  data-menu-chrome-scroll
                  on:scroll={handleMenuListScroll}
                >
                  {#if inviteFriendPanel}
                    <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #e5e7eb;">
                      <div style="font-weight: 600; font-size: 16px;">Invitation Link</div>
                      <button 
                        on:click={() => {
                          inviteFriendPanel = false;
                          inviteClipboardTxt = "";
                        }}
                        style="background: none; border: none; font-size: 18px; cursor: pointer; color: #6b7280; padding: 4px;"
                        title="Close Invitation Link"
                      >
                        ×
                      </button>
                    </div>
                    <div class="w-full flex items-center" style="padding: 10px;">
                      <div id="inviteclipboard" />
                      <div
                        class="flex items-center"
                        class:border-green={tutorialStep == 3 && (tutorialNumber == 6)}
                        style="justify-content: space-between;width: 100%;"
                        class:hidden={inviteClipboardTxt == ""}
                      >
                        <span style="word-break: break-all;"
                          >{inviteClipboardTxt}</span
                        >
                        <img
                          src="filter.svg"
                          class="cursor-pointer"
                          style="width: 30px; margin-left: 15px;"
                          on:click={copyInviteUrl}
                          alt="Copy"
                        />
                      </div>
                    </div>
                  {:else}
                    {#if friends.length > 0}
                      <div class="main-menu-popup__team-heading">Team Members</div>
                      {#each friends as friend}
                        {#if searchKeyFriend == "" || friend.email.includes(searchKeyFriend.toLowerCase())}
                          <div
                            class="signItem main-menu-popup__member-row"
                            data-testid="team-member-row"
                          >
                            <div
                              class="main-menu-popup__member-star"
                              aria-hidden={friend.id !== user.appId}
                            >
                              {#if friend.id === user.appId}
                                <svg
                                  class="member__star"
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  width="12"
                                  height="12"
                                  viewBox="0 0 511.987 511"
                                  xml:space="preserve"
                                >
                                  <path
                                    fill="#ffc107"
                                    d="M510.652 185.902a27.158 27.158 0 0 0-23.425-18.71l-147.774-13.419-58.433-136.77C276.71 6.98 266.898.494 255.996.494s-20.715 6.487-25.023 16.534l-58.434 136.746-147.797 13.418A27.208 27.208 0 0 0 1.34 185.902c-3.371 10.368-.258 21.739 7.957 28.907l111.7 97.96-32.938 145.09c-2.41 10.668 1.73 21.696 10.582 28.094 4.757 3.438 10.324 5.188 15.937 5.188 4.84 0 9.64-1.305 13.95-3.883l127.468-76.184 127.422 76.184c9.324 5.61 21.078 5.097 29.91-1.305a27.223 27.223 0 0 0 10.582-28.094l-32.937-145.09 111.699-97.94a27.224 27.224 0 0 0 7.98-28.927zm0 0"
                                  ></path>
                                </svg>
                              {/if}
                            </div>
                            <div class="main-menu-popup__member-info">
                              <div class="main-menu-popup__member-email">{friend.email}</div>
                              <div
                                class="main-menu-popup__member-meta"
                                class:main-menu-popup__member-meta--stale={Date.now() - friend.loggedIn > 432000000}
                              >
                                Logged In {timeAgo(friend.loggedIn)}
                              </div>
                            </div>
                          </div>
                        {/if}
                      {/each}
                    {:else}
                      <div class="text-center" style="padding: 20px;">There is no data.</div>
                    {/if}
                  {/if}
                </div>
              {/if}
            </div>          
          </div>
        </div>
        
      </div>
    </DefaultPopup>
    {#if isMobile && newProfilePanel}
      <label
        class="main-menu-popup__upload-fab"
        for="pdf"
        data-testid="menu-upload-fab"
        title="Upload new document"
      >
        <span aria-hidden="true">+</span>
        <span class="sr-only">Upload new document</span>
      </label>
    {/if}
  {/if}
</div>

<style lang="scss" scoped>

  @import '../../style/variables.scss'; // Adjust the path as needed

  :global(.main-menu-popup) {
    max-width: 1100px;
    padding: 15px 25px;
    width: calc(100% - 30px);
    height: 80vh;

    @media (max-width: $laptop-width) and (min-width: $phone-width-lg) {
      height: 90vh;
    }

    @media (max-width: $tablet-width) {
      padding: 12px 12px;
      width: 100%;
      max-width: 100%;
      height: calc(100svh - 150px);
      max-height: calc(100svh - 150px);
      border-radius: 0;
    }
  }

  .transition-color {
    transition: color 0.3s;
  }

  .main-menu-popup {

    &__inner {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    &__user {
      margin: 10px 0 30px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-right: auto;
      flex-wrap: nowrap;
      gap: 8px;
      max-width: 100%;

      @media (max-width: $laptop-width) {
        margin-bottom: 10px;
      }

      @media (max-width: $phone-width-lg) {
        margin-bottom: 8px;
        width: 100%;
        flex-wrap: wrap;
      }
    }

    &__user-email {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &__user-type {
      width: 22px;
      height: auto;
      aspect-ratio: 1 / 1;
      margin-right: 15px;
      flex-shrink: 0;

      @media (max-width: $laptop-width) {
        width: 22px * $laptop-width-mp;
      }
    }

    &__logout {
      width: auto;
      flex-shrink: 0;
      margin-left: 20px;
      background-color: #fff;
      padding: 5px 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      font-weight: 600;
      color: #009AE4;
      cursor: pointer;
      margin-right: 60px;
      transition: background-color 0.3s;

      @media (max-width: $phone-width-lg) {
        margin-left: 0;
        margin-right: 0;
        width: auto;
        min-width: 88px;
        padding: 6px 12px;
      }

      &:hover {
        background-color: #e4e4e4;
      }

      &.theme-dark {
        background-color: $dark-bg;

        &:hover {
          background-color: $dark-bg-darker;
        }
      }
    }

    &__tabs {
      display: flex;
      align-items: center;
      position: relative;
      margin-right: auto;
      margin-bottom: 30px;
      padding-left: 5px;
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;

      @media (max-width: $laptop-width) {
        margin-bottom: 30px;
        padding-left: 0;
      }

      @media(max-width: $phone-width-lg) {
        margin-bottom: 20px;
        gap: 0;
      }
    }

    &__tab {
      width: 33.333%;
      max-width: 200px;
      padding: 10px 50px;
      font-size: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
      transition: color 0.4s;
      position: relative;
      z-index: 2;
      cursor: pointer;
      background-color: transparent;
      border: none;
      outline: none;
      font-weight: 500;
      transition: color 0.3s;

      &.theme-dark {
        color: #fff;
      }

      @media(max-width: $laptop-width) {
        font-size: 0.9em;
        padding: 7px 25px;
      }

      @media(max-width: $phone-width-lg) {
        font-size: 0.75rem;
        padding: 8px 10px;
        flex: 0 0 auto;
        min-width: 72px;
        max-width: none;
        width: auto;
        white-space: nowrap;
        border-radius: 30px;
      }

      &--active, &:hover  {
        color: #00bbf9;
      }

      @media (max-width: 767px) {
        &--active {
          background-color: #def2fd;
          color: #009AE4;
        }
      }
    }

    &__tab-indicator {
      color: transparent;
      width: 20%;
      max-width: 200px;
      padding: 10px 20px;
      background-color: #def2fd;
      border-radius: 30px;
      position: absolute;
      z-index: 1;
      left: 0;
      transition: transform 0.4s, background-color 0.3s;

      &.theme-dark {
        background-color: $dark-bg-darker;
      }

      @media(max-width: $laptop-width) {
        font-size: 0.9em;
        padding: 7px 25px;
      }

      /* Sliding indicator only works with equal-width desktop tabs */
      @media (max-width: 767px) {
        display: none !important;
      }
    
      &--completed {
        transform: translateX(100%);
      }

      &--templates {
        transform: translateX(210%);
      }
      &--integration {
        transform: translateX(315%);
      }
      &--team {
        transform: translateX(410%);
      }
    }

    &__body {
      position: relative;
      width: 100%;
      flex-grow: 1;
      overflow: auto;
      overflow-x: hidden;
      scrollbar-width: none;
      -moz-scrollbar-width: thin;

      &::-webkit-scrollbar {
        width: 8px;
      }

      // &::-webkit-scrollbar-track {
      //   background: #f1f1f1;
      //   border-radius: 4px;
      // }

      // &::-webkit-scrollbar-thumb {
      //   background: #888;
      //   border-radius: 4px;
      // }

      // &::-webkit-scrollbar-thumb:hover {
      //   background: #555;
      // }

    }

    &__view {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      display: flex;
      transition: transform 0.4s;

      &--left {
        transform: translateX(-150%);
      }

      &--right {
        transform: translateX(150%);
      }
    }

    &__tab-loading {
      flex: 1 1 auto;
      width: 100%;
      min-height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }

    &__messaging-tutorial {
      position: absolute;
      bottom: 20px;
      left: 20px;
      z-index: 10;
      max-width: 70%;
    }

    &__team {
      max-width: 1700px;
      width: 100%;
      margin: 0 auto;
    }

    &__team-heading {
      font-weight: 600;
      padding: 10px;
      font-size: 16px;
    }

    &__member-row {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      align-items: flex-start !important;
      gap: 10px !important;
      box-sizing: border-box;
    }

    &__member-star {
      flex: 0 0 14px;
      width: 14px;
      min-width: 14px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 2px;
    }

    &__member-info {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    &__member-email {
      font-size: 14px;
      line-height: 1.35;
      word-break: break-word;
      overflow-wrap: anywhere;
    }

    &__member-meta {
      font-size: 12px;
      line-height: 1.3;
      color: #6b7280;

      &--stale {
        color: #ef4444;
      }
    }

    &__automation {
      max-width: 970px;
      width: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
    }

    &__team-toolbar {
      @media (max-width: 767px) {
        /* shared via .main-menu-popup__toolbar mobile.css */
      }
    }

    &__toolbar {
      display: flex;
      align-items: center;
      gap: 10px;

      @media (max-width: 767px) {
        flex-wrap: wrap;
        gap: 8px;
      }
    }

    &__toolbar-search {
      height: 40px;
      box-sizing: border-box;
    }

    &__toolbar-btn {
      display: inline-flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 6px;
      height: 40px;
      white-space: nowrap;
      flex-wrap: nowrap;

      @media (max-width: 767px) {
        min-width: 0;
      }
    }

    &__team-btn {
      @media (max-width: 767px) {
        min-width: 0 !important;
      }
    }
  }


* {
  &::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8 !important;
}
&::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(83, 83, 83, 0.07);
  background-color: #f1f1f1;
}
&::-webkit-scrollbar {
  width: 7px;
  background-color: #f1f1f1;
}
&::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}
}
</style>
